// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"cd3d660c","311":"258a3b0e","409":"b7fb2541","580":"737f1878","887":"63bf28de","895":"090675e2","904":"38aed90f","986":"b8a5bb95"}[chunkId] + ".chunk.js";
};